import { Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './styles';
const Menu = () => {
  const classes = useStyles();
  return (
    <Toolbar className={classes.toolBar}>
      <Typography variant="h6">Liste des discussions</Typography>
    </Toolbar>
  );
};
export default Menu;
